<template>
  <div>
    <a-modal :title="title" v-model="visible" @ok="handleOk" class="cancel-out-model1">
        <div class="cancel-out-image">
          <img src="@/assets/image/tishi.png" alt="" class="image">
          <span>{{content}}</span>
        </div>
      </a-modal>
  </div>
</template>

<script>
export default {
  name: 'deleteModal',
  data () {
    return {
      title: '温馨提示',
      visible: false,
      record: {},
      content: '',
    }
  },
  methods: {
    show (record) {
      this.visible = true
      this.record = record
      if (!this.isEmpty(record.content)) {
        this.content = record.content
      } else {
        this.content = '您确认要删除单据吗？'
      }
    },
    cancel () {
      this.visible = false
    },
    handleOk () {
      this.visible = false
      this.$emit('confirmDeletion', this.record)
    }
  }
}
</script>
<style lang="scss">
.cancel-out-model1 {
  width: 460px !important;
  height: 200px !important;
  .ant-modal-content {
    height: 220px;
    border-radius: 10px;
    .ant-modal-header {
      border-radius: 10px 10px 0 0;
    }
    .ant-modal-body {
      height: 60px !important;
      display: flex;
      justify-content: center;
      padding: 0;
    }
    .ant-btn {
      width: 140px;
      border-radius: 6px !important;
    }

    .cancel-out-image {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      .image {
        width: 32px;
        height: 32px;
        margin-right: 8px;
      }
    }
  }
}
</style>
